module.exports = __webpack_public_path__ + "img/tiktok.4f473257.svg";